import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    MenuItem,
    Stack,
    Typography,
} from '@mui/material';

interface Props {
    open: boolean;
    onClose: () => void;
    fundName: string;
}

const SipSchedulerModal = ({ open, onClose, fundName }: Props) => {
    const [amount, setAmount] = useState('');
    const [day, setDay] = useState('1');
    const [frequency, setFrequency] = useState('monthly');

    const handleSubmit = () => {
        // API call placeholder
        console.log({ fundName, amount, day, frequency });
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Set up SIP</DialogTitle>

            <DialogContent>
                <Stack spacing={2} mt={1}>
                    <Typography variant="body2" color="text.secondary">
                        Fund: <strong>{fundName}</strong>
                    </Typography>

                    <TextField
                        label="Monthly Amount (₦)"
                        type="number"
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                        fullWidth
                    />

                    <TextField
                        select
                        label="Debit Day"
                        value={day}
                        onChange={(e) => setDay(e.target.value)}
                    >
                        {[...Array(28)].map((_, i) => (
                            <MenuItem key={i + 1} value={i + 1}>
                                Day {i + 1}
                            </MenuItem>
                        ))}
                    </TextField>

                    <TextField
                        select
                        label="Frequency"
                        value={frequency}
                        onChange={(e) => setFrequency(e.target.value)}
                    >
                        <MenuItem value="monthly">Monthly</MenuItem>
                        <MenuItem value="quarterly">Quarterly</MenuItem>
                    </TextField>
                </Stack>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button
                    variant="contained"
                    onClick={handleSubmit}
                    disabled={!amount}
                >
                    Activate SIP
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SipSchedulerModal;
